import { useEffect, useState } from "react";
import { AddToCalendar } from "./AddToCalendar";
import { RemindMe } from "./RemindMe";

const DEFAULT_EVENTS = [
  { id: "video-game-tournaments", name: "Video Game Tournaments", date: null },
  { id: "tcg-tournaments", name: "Pokémon & Other Trading Card Game Tournaments", date: null },
  { id: "parents-night-out", name: "Parents Night Out", date: null },
];

const formatDate = (iso) =>
  new Date(iso).toLocaleString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });

export const Reviews = () => {
  const [events, setEvents] = useState(DEFAULT_EVENTS);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data?.events?.length) setEvents(data.events);
      })
      .catch(() => {});
  }, []);

  return (
    <section data-testid="reviews-section" className="py-20 md:py-28 px-6 md:px-12 max-w-6xl mx-auto">
      <div className="border-2 border-dashed border-[#4A2E66] rounded-2xl p-8 md:p-12 bg-[#20123A]">
        <span className="mono-lbl text-xs uppercase text-[#FF2E88] font-bold">What&apos;s On</span>
        <h3 className="display-type text-2xl md:text-4xl font-bold uppercase mt-2 mb-8">
          Special Events
        </h3>
        <div className="grid sm:grid-cols-3 gap-4 max-w-4xl mx-auto">
          {events.map((e) => (
            <div
              key={e.id}
              data-testid={`event-${e.id}`}
              className="bg-[#26153F] border border-[#3B2760] rounded-xl p-5 text-center"
            >
              <p className="font-bold text-sm">{e.name}</p>
              <p data-testid={`event-date-${e.id}`} className="text-xs text-[#A08FB8] mt-1">
                {e.date ? formatDate(e.date) : "Date to be announced"}
              </p>
              <AddToCalendar event={e} />
              <div><RemindMe event={e} /></div>
            </div>
          ))}
        </div>
        <p className="text-xs text-[#A08FB8] max-w-md mx-auto mt-8 text-center">
          Dates are announced here and on our Facebook page. Tap a calendar button to save an event.
        </p>
      </div>
    </section>
  );
};
